import React from "react";
import { MicroscopeMark } from "./BrandMark";

export function DashIntro({dark}){
  // 3 concentric rings, staggered
  const rings = [0, 180, 360];
  return (
    <div style={{
      position:"absolute",inset:0,zIndex:500,pointerEvents:"none",
      display:"flex",alignItems:"center",justifyContent:"center",
      animation:"introFade 2.8s ease forwards",
      background: dark
        ? "radial-gradient(ellipse at center, rgba(30,26,18,0.96) 0%, rgba(26,26,26,0.0) 70%)"
        : "radial-gradient(ellipse at center, rgba(255,252,240,0.96) 0%, rgba(255,255,255,0.0) 70%)",
    }}>
      {/* Shockwave rings */}
      {rings.map((delay,i)=>(
        <div key={i} style={{
          position:"absolute",
          width:90,height:90,borderRadius:"50%",
          border:`1.5px solid ${dark?"rgba(226,221,159,0.55)":"rgba(180,140,40,0.45)"}`,
          animation:`ringPulse 1.4s cubic-bezier(.2,.8,.4,1) ${delay}ms forwards`,
        }}/>
      ))}
      {/* Outer soft glow halo */}
      <div style={{
        position:"absolute",
        width:160,height:160,borderRadius:"50%",
        background:dark
          ? "radial-gradient(circle, rgba(226,221,159,0.14) 0%, transparent 70%)"
          : "radial-gradient(circle, rgba(200,160,50,0.18) 0%, transparent 70%)",
        animation:"ringPulse 1.8s ease 120ms forwards",
      }}/>
      {/* Microscope */}
      <div style={{ position:"relative", zIndex:2, display:"flex",
        animation:"microDrop .72s cubic-bezier(.34,1.56,.64,1) forwards" }}>
        {/* The vector mark, not the 80x100 PNG, and no drop-shadow filter
            on a moving element: the halo above already glows. */}
        <MicroscopeMark size={56}/>
      </div>    </div>
  );
}
